function Disclaimer() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="prose prose-lg max-w-none">
        <h1 className="text-3xl font-bold mb-8">Disclaimer</h1>
        
        <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-8">
          <p className="text-blue-700">
            Please read this disclaimer carefully before using our website.
          </p>
        </div>

        <div className="space-y-6">
          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">General Information Purpose</h2>
            <p>
              The information and content generated on https://contentcreatorai.com is created using artificial intelligence 
              technology and is provided for general information purposes only. While our AI systems strive to provide 
              accurate and helpful content, they can make mistakes, generate incorrect information, or produce unexpected 
              results. The content is provided "as is" without any warranties, and any reliance you place on such 
              AI-generated information is strictly at your own risk. We strongly recommend reviewing, fact-checking, 
              and independently verifying any important information before use. We make no representations or warranties 
              about the accuracy, completeness, reliability, or suitability of the AI-generated content for any purpose.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">Limitation of Liability</h2>
            <p>
              In no event will we be liable for any loss or damage including without limitation, indirect or 
              consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits 
              arising out of, or in connection with, the use of https://contentcreatorai.com.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">External Links</h2>
            <p>
              Through https://contentcreatorai.com you are able to link to other websites which are not under 
              the control of https://contentcreatorai.com. We have no control over the nature, content and 
              availability of those sites. The inclusion of any links does not necessarily imply a recommendation 
              or endorse the views expressed within them.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">Website Availability</h2>
            <p>
              Every effort is made to keep https://contentcreatorai.com up and running smoothly. However, 
              https://contentcreatorai.com takes no responsibility for, and will not be liable for, 
              https://contentcreatorai.com being temporarily unavailable due to technical issues beyond our control.
            </p>
          </section>
        </div>

        <div className="mt-12 text-sm text-gray-600">
          Last updated: December 23, 2024
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
